var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.0813L11.0434 12.9688H28.9565L20 20.0813ZM20 22.2159C19.7938 22.2159 19.5877 22.1482 19.417 22.0126L9.21875 13.9141V26.5039C9.21875 26.7947 9.45531 27.0312 9.74609 27.0312H30.2539C30.5447 27.0312 30.7812 26.7947 30.7812 26.5039V13.914L20.583 22.0127C20.4123 22.1482 20.2061 22.2159 20 22.2159ZM40 6.12445V33.8756C40 37.2526 37.2526 40 33.8755 40H6.12445C2.74742 40 0 37.2526 0 33.8755V6.12445C0 2.74742 2.74742 0 6.12445 0H33.8756C37.2526 0 40 2.74742 40 6.12445ZM32.6562 13.4961C32.6562 12.1714 31.5786 11.0938 30.2539 11.0938H9.74609C8.42141 11.0938 7.34375 12.1714 7.34375 13.4961V26.5039C7.34375 27.8286 8.42141 28.9062 9.74609 28.9062H30.2539C31.5786 28.9062 32.6562 27.8286 32.6562 26.5039V13.4961Z",
    fill: "#034A73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d88d5869d28ee47094f34f802e6096ef.svg";
export { ForwardRef as ReactComponent };